import { useData } from '../../utils/hooks/useData';
import { formatFromAndToQuery, calculatePercentageDifference } from '../lib';
import { useAnalyticsStoreContext } from '../contexts';

import AnalyticsError from '../AnalyticsError';
import { useMergedData } from '../../utils/hooks/useMergedData';

export default function TopSources({ endpoints }) {
  const { top_sources_api_v1_cms_analytics_path, admin_analytics_report_sources_path } = endpoints;

  const dateRange = useAnalyticsStoreContext((state) => state.data.first.dateRange);
  const dateRangeTwo = useAnalyticsStoreContext((state) => state.data.second.dateRange);
  const isComparing = useAnalyticsStoreContext((state) => state.isComparing);

  const { data, isLoading, error } = useData(`${top_sources_api_v1_cms_analytics_path}.json?${formatFromAndToQuery(dateRange)}`);

  const {
    data: dataTwo,
    isLoading: isLoadingTwo,
    error: errorTwo,
  } = useData(`${top_sources_api_v1_cms_analytics_path}.json?${formatFromAndToQuery(dateRangeTwo)}`, isComparing && dateRangeTwo.from && dateRangeTwo.to, []);

  const mergedData = useMergedData(data, dataTwo, isComparing, { isInclude: false });

  return (
    <div className="card card-fill">
      <div className="card-header">Top Sources</div>
      <table className="table table-sm card-table">
        <thead>
          <tr>
            <th>Source</th>
            <th>Visits</th>
            {isComparing && dataTwo.length ? <th>Visits (prior)</th> : null}
          </tr>
        </thead>
        <tbody>
          {isLoading || isLoadingTwo ? (
            <tr>
              <td colSpan={2}>
                <div className="d-flex align-items-center justify-content-center" style={{ height: 100 }}>
                  <div className="spinner-border" role="loading">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              </td>
            </tr>
          ) : error || errorTwo ? (
            <tr>
              <td colSpan={2}>
                <div className="d-flex flex-column align-items-center justify-content-center" style={{ height: 100 }}>
                  {error && (
                    <div className="d-flex gap-2">
                      <span>First Dataset:</span>
                      <AnalyticsError errorMsg={error} />
                    </div>
                  )}
                  {errorTwo && (
                    <div className="d-flex gap-2">
                      <span>Second Dataset:</span>
                      <AnalyticsError errorMsg={errorTwo} />
                    </div>
                  )}
                </div>
              </td>
            </tr>
          ) : (
            mergedData.map((source, index) => (
              <tr key={index}>
                <td>{source[0]}</td>
                <td className="w-25">{source[1]}</td>
                {source[2] && (
                  <td className="w-25">
                    {source[2]} <small className="text-muted">{calculatePercentageDifference(source[1], source[2])}</small>
                  </td>
                )}
              </tr>
            ))
          )}
        </tbody>
      </table>
      <div className="card-footer text-end">
        <a href={admin_analytics_report_sources_path}>View all...</a>
      </div>
    </div>
  );
}
